import { useTranslation } from "react-i18next";
import {
  Controller,
  Control,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";
import { NumericFormat } from "react-number-format";

interface InputTextProps<FieldsType extends FieldValues> {
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  rules?: RegisterOptions<FieldsType>;
  label?: string;
  required?: boolean;
  shouldUnregister?: boolean;
  placeholder?: string;
  requiredMessage?: string;
}

export default function PriceInput<FieldsType extends FieldValues>({
  placeholder,
  label,
  name,
  control,
  required,
  shouldUnregister,
  requiredMessage,
  rules,
}: InputTextProps<FieldsType>) {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: requiredMessage || (required && "Required"),
        ...(rules || {}),
      }}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState: { error } }) => {
        return (
          <div className="relative">
            {label && (
              <label
                className="text-base ml-1 mb-0.5 block"
                htmlFor={field?.name}
              >
                <span>
                  {t(label)}
                  {(required || requiredMessage) && (
                    <span className="text-red-600 ml-0.5 text-base">*</span>
                  )}
                </span>
              </label>
            )}
            <NumericFormat
              id={field.name}
              getInputRef={field.ref}
              name={field.name}
              defaultValue={field.value}
              prefix="$ "
              thousandSeparator
              placeholder={t(placeholder || "$ 0.00")}
              className="placeholder:text-gray-500 border-gray-200 rounded-lg w-full px-2.5 py-3 border focus:border-brand-hover
            focus-within:border-brand-hover focus:bg-[#eaf1fa]  transition-all focus:ring-0 focus-visible:ring-0 focus-visible:border-brand-hover  outline-none"
              onValueChange={({ value }) => field.onChange(value)}
              valueIsNumericString={false}
            />
            <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
              {t(error?.message)}
            </p>
          </div>
        );
      }}
    />
  );
}
